import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Språkresurser. Svenska är käll-språket; övriga är översättningar av gränssnittet.
// Användar-innehåll (anslag, företag, berättelser) ligger kvar på svenska.
import sv from "./locales/sv.json";
import se from "./locales/se.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import uk from "./locales/uk.json";
import ru from "./locales/ru.json";
import th from "./locales/th.json";

export const LANGUAGES = [
  { code: "sv", label: "Svenska",    flag: "🇸🇪" },
  { code: "se", label: "Sámegiella", flag: "ᚼ" },
  { code: "en", label: "English",    flag: "🇬🇧" },
  { code: "de", label: "Deutsch",    flag: "🇩🇪" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "pl", label: "Polski",     flag: "🇵🇱" },
  { code: "uk", label: "Українська", flag: "🇺🇦" },
  { code: "ru", label: "Русский",    flag: "🇷🇺" },
  { code: "th", label: "ไทย",         flag: "🇹🇭" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv },
      se: { translation: se },
      en: { translation: en },
      de: { translation: de },
      nl: { translation: nl },
      pl: { translation: pl },
      uk: { translation: uk },
      ru: { translation: ru },
      th: { translation: th },
    },
    fallbackLng: "sv",
    supportedLngs: LANGUAGES.map(l => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "vidalv_lang",
    },
    returnNull: false,
  });

// Uppdatera <html lang>
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") document.documentElement.lang = lng;
});

export default i18n;
